import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'
import _imports_1 from '../../assets/images/header/home.png'
import _imports_2 from '../../assets/images/header/service.png'
import _imports_3 from '../../assets/images/header/sustainability.png'
import _imports_4 from '../../assets/images/header/activity.png'
import _imports_5 from '../../assets/images/header/contact.png'


const _withScopeId = n => (_pushScopeId("data-v-de364060"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Smart Process",
  width: "263",
  height: "35"
}, null, -1))
const _hoisted_2 = { class: "home" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "HOME",
  width: "",
  height: "20"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "SERVICE",
  width: "",
  height: "20"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "SUSTAINABILITY",
  width: "",
  height: "24"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "ACTIVITY",
  width: "",
  height: "24"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "CONTACT",
  width: "",
  height: "20"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-bg" }, null, -1))
const _hoisted_10 = { class: "service-submenu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("h1", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          class: "service-nav",
          onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showSubmenu && _ctx.showSubmenu(...args)))
        }, _hoisted_5, 32),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/sustainability" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/activity" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/contact" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.isShowSubmenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideSubmenu && _ctx.hideSubmenu(...args))),
                class: "service-submenu-wrapper"
              }, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_link, { to: "/service/digital" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" ＞ Process Consulting Service ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/service/process" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" ＞ Workshop ")
                    ]),
                    _: 1
                  })
                ])
              ], 32))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}